export const sentry = async (): Promise<boolean> => {
  if (!window.electron?.sentry) {
    return false;
  }

  return window.electron.sentry();
};
